module.exports = __webpack_public_path__ + "img/icn-english.86dc54cf.svg";